export default __webpack_public_path__ + "static/bunker-footer-mobile-1e9c2985371369dbf5eac335917a5694.jpg";